import React from "react";
import { Link } from "react-router-dom";
import { useTable } from "@/lib/store";
import { Card, PageHead, Chip, Avatar, Kicker, SectionHead } from "@/components/kit";
import { ArrowUpRight } from "lucide-react";

export default function Members() {
  const { members, year, activeMembers } = useTable();
  const active = members.filter((m) => m.status === "Active");
  const alumni = members.filter((m) => m.status === "Alumni");

  const badge = (m) => {
    if (!year) return null;
    if (m.id === year.moderatorId) return <Chip color="var(--brass)">Moderator</Chip>;
    if (m.id === year.coModeratorId) return <Chip color="var(--brass)">Co-Moderator</Chip>;
    return null;
  };

  const Grid = ({ list, testPrefix }) => (
    <div className="grid sm:grid-cols-2 gap-5 stagger">
      {list.map((m) => (
        <Link key={m.id} to={`/members/${m.id}`} data-testid={`${testPrefix}-${m.id}`}>
          <Card lift className="group flex gap-5 items-center h-full">
            <Avatar name={m.name} color={m.avatarColor} size={52} dim={m.status === "Alumni"} />
            <div className="min-w-0 flex-1">
              <div className="serif text-[1.35rem] leading-tight">{m.name}</div>
              <div className="text-[13px] mt-1.5" style={{ color: "var(--ink-mute)" }}>
                {m.company}
              </div>
              {badge(m) && <div className="mt-3">{badge(m)}</div>}
            </div>
            <ArrowUpRight
              size={15}
              className="shrink-0 opacity-0 group-hover:opacity-60"
              style={{ color: "var(--brass)", transition: "opacity .25s var(--ease)" }}
            />
          </Card>
        </Link>
      ))}
    </div>
  );

  return (
    <div data-testid="members-page">
      <PageHead
        kicker={`${activeMembers.length} seats`}
        title="Members"
        sub="The room. Confidentiality is the price of entry."
      />
      <Grid list={active} testPrefix="member-card" />
      {alumni.length > 0 && (
        <div className="mt-12">
          <SectionHead>Alumni</SectionHead>
          <Grid list={alumni} testPrefix="alumni-card" />
        </div>
      )}
    </div>
  );
}
